import shared from '../../data/js/shared';

export const {
  browse: {
    noResultsHeading,
    noResultsHeading2,
    resultsHeading,
    loadMoreLabel,
    loadingLabel,
    backToTopLabel,
    doneListingLabel,
  },
} = shared;

export const SHOWCASES_PER_PAGE = 4;
